import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

let BUILD_TIME = 2;

class Api {

    showError(data){
        if(typeof data == "string")
            data = {
                error: data
            }
        let err = data.error;
        let args = [err];
        if(NODE_ENV == 'development' || NODE_ENV == 'test')
            alert(err)

        if(NODE_ENV == 'development' || NODE_ENV == 'test'){
            args.unshift("(Error code: " + data.code + ") ");
            args.push("\n\rFile: " + data.file + " " + data.line);
            args.push(data.trace);
        }

        console.error.apply(document, args);
    }
    errorHandler(data){
        if(typeof data == "object" && typeof data.errors == "object" && data.errors.indexOf('auth') != -1 && data.location){
            return window.location.href = data.location.replace(/url_redirect_url/i, encodeURIComponent(window.location.href))
        }
        return this.showError(data)
    }
    /*
    showError(data){
        if(NODE_ENV == 'development' || NODE_ENV == 'test')
            alert(data)
        else
            console.error(data)
    }
    errorHandler(data){
        if(typeof data == "string"){
            this.showError('API error: ' + data)
        }else if(data.errors.indexOf('auth') != -1 && data.location){
            window.location.href = data.location.replace(/url_redirect_url/i, encodeURIComponent(window.location.href))
        }
    }
    */
    responseHandler(resp){
        if(resp.body.success){
            return resp.body.data
        }else(
            this.errorHandler(resp.body.data)
        )
    }
    httpErrorHandler(resp){
        this.showError("HTTP error: " + resp.status + " " + resp.statusText + " " + resp.body.data )
    }
    getWorkshops() {
        return Vue.http.get(`/wp-json/mps/workshops/10?mps_v=${BUILD_TIME}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getCompanies() {
        return Vue.http.get(`/wp-admin/admin-ajax.php?action=mps_get_companies&mps_v=${BUILD_TIME}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getCompanyTypes() {
        return Vue.http.get(`/wp-admin/admin-ajax.php?action=mps_get_company_types&mps_v=${BUILD_TIME}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    saveCompany(company, file) {
        let url = `/wp-admin/admin-ajax.php?action=mps_save_company`;

        var formData = new FormData();
        formData.append("files[0]", file);
        formData.append('json_data', JSON.stringify(company));
        return Vue.http.post(url, formData).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getCompany(id) {
        return Vue.http.get(`/wp-admin/admin-ajax.php?action=mps_get_company&id=${id}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getDamageOfferTexts( id_workshop ) {
        let self = this;
        return Vue.http.get(`/wp-admin/admin-ajax.php?action=mps_opq_get_damage_offer_texts&id_workshop=${id_workshop}&mps_v=${BUILD_TIME}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getWidgetsData() {
        var self = this
        return Vue.http.get('/wp-admin/admin-ajax.php?action=mps_admin_data').then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getCarModel(id) {
        return Vue.http.get(`/wp-json/mps/cars/${id}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getContact(phone) {
        return Vue.http.get(`/wp-json/mps/contacts/${phone}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getPartner(name) {
        return Vue.http.get(`/wp-json/mps/partners/${name}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    updateDamages(data, files) {
        var url = `/wp-admin/admin-ajax.php?action=mps_opq_update_damages`;

        var formData = new FormData();
        files.forEach(function(item, i, arr) {
            if(item.file) formData.append("files[" + i + "]", item.file);
        });
        formData.append('json_data', JSON.stringify(data));
        return Vue.http.post(url, formData).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    sendRequest(data, files) {
        var url = `/wp-admin/admin-ajax.php?action=add_report_from_form`;

        var formData = new FormData();

        if (data.damages.length) {
            for (var i = 0; i < data.damages.length; i++) {
                var damage =  data.damages[i];

                if (damage.images.length) {
                    for (var k = 0; k < damage.images.length; k++) {
                        var imageFileIndex = damage.images[k];
                        var item = files[imageFileIndex];

                        if (item) {
                            formData.append("image_" + (i + 1) + "_" + (k + 1), item.file, item.name);
                        }
                    }
                }
            }
        }

        formData.append('json_data', JSON.stringify(data));

        return Vue.http.post(url, formData).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    setRequestAsFinished(data){
        let url = `/wp-admin/admin-ajax.php?action=mps_opq_finish_request`;
        return Vue.http.post(url,  data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    deleteRequest( code, data ){
        console.log(data)
        let url = `/wp-admin/admin-ajax.php?action=mps_opq_delete_request&code=${code}`;
        return Vue.http.post(url,  data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    setRequestAsContacted( code, data ){
        let url = `/wp-admin/admin-ajax.php?action=mps_opq_set_request_contacted&code=${code}`;
        return Vue.http.post(url,  data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    updateConsent(contact) {
       
        console.log("API update consent:");
	 	
	 	var data = {"contact" : contact };
	    //data["contact"] = contact;
	    console.log(data);
	    
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_opq_update_consent`, data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }

    sendOffer(data) {
        var self = this;
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_opq_offer`, data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    sendComment(data) {
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_opq_new_comment`, data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getRequest(code, type){
        return Vue.http.get(`/wp-admin/admin-ajax.php?action=mps_opq_get_request&code=${code}&type=${type}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    considerOffer(data) {
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_opq_consider_offer`, data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    sendSms(data) {
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_opq_send_sms`, data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    saveWorkshop(workshop) {
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_save_workshop`, {workshop: workshop}, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    saveDamageOfferTexts(id_workshop, texts) {
        return Vue.http.post(`/wp-admin/admin-ajax.php?action=mps_opq_save_damage_offer_texts&id_workshop=${id_workshop}`, {texts: texts}, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getWorkshop(id) {
        return Vue.http.get(`/wp-admin/admin-ajax.php?action=mps_get_workshop&id=${id}`).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    exportToXbulk(data){
        let url = `/wp-admin/admin-ajax.php?action=mps_opq_export_to_xbulk`;
        return Vue.http.post(url, data, { emulateJSON: true }).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
    getXbulkWorkshops() {
        let url;
        if( NODE_ENV == 'production' )
            url = '//xbulk.no/wp-json/xbulk/workshops/10?v=3';
        if( NODE_ENV == 'test' )
            url = '//xbulk.wpengine.com/wp-json/xbulk/workshops/10?v=3';

        return Vue.http.get(url).then(
            this.responseHandler.bind(this),
            this.httpErrorHandler.bind(this)
        )
    }
}

export default Api



// WEBPACK FOOTER //
// ./requests/assets/src/api/index.js